module.exports = __webpack_public_path__ + "static/media/trowel.bd6e338d.svg";